// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getKendaraan, insertKendaraan, kendaraanSelector, updateKendaraan,} from "./kendaraanSlice";

import {Colors} from "../../../assets/Colors";

const KendaraanPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const kendaraan = useSelector(kendaraanSelector);

    useEffect(() => {
        dispatch(
            getKendaraan({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && kendaraan.isGetSuccess && !kendaraan.isGetFetching) {
            let calc = kendaraan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kendaraan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (
            search === "" &&
            kendaraan.isGetSuccess &&
            !kendaraan.isGetFetching
        ) {
            let calc = kendaraan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kendaraan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !kendaraan?.isGetFetching &&
            kendaraan.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = kendaraan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kendaraan.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getKendaraan({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (kendaraan.isGetSuccess) {
                alertService.success(kendaraan.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getKendaraan({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (kendaraan.isUpdateSuccess) {
                alertService.success(kendaraan.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateKendaraan({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetKendaraan(params) {
    //   return dispatch(getKendaraan(params));
    // }

    function handleInsertKendaraan(param) {
        setInsertFetch(true);
        const params = {
            NamaKendaraan: param.inputOneValue,
            KategoriKendaraanID: param.dropDownKendaraanValue,
        };

        dispatch(insertKendaraan(params));
    }

    function handleUpdateKendaraan(param) {
        setUpdateFetch(true);

        const params = {
            NamaKendaraan: param.inputOneValue,
            KendaraanID: currentData.KendaraanID,
            KategoriKendaraanID: param.dropDownKendaraanValue,
            status: param.status,
        };
        dispatch(updateKendaraan(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getKendaraan(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getKendaraan(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = kendaraan.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? kendaraan.count : newCount,
            search: search,
        };
        dispatch(getKendaraan(params));

        setPage(1);
        setCount(newCount === "-1" ? kendaraan.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Kendaraan"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Kendaraan"
                                tableData={kendaraan.data}
                                colOneTitle="ID"
                                colOneData="KendaraanID"
                                colTwoTitle="Nama Unit"
                                colTwoData="NamaKendaraan"
                                colThreeTitle="Kategori"
                                colThreeData="CategoryName"
                                status="Status"
                                fetching={kendaraan.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Unit"
                        inputOneTitle="Nama Unit"
                        dropDownKendaraan={true}
                        dropDownKendaraanValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertKendaraan}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.KendaraanID}
                        modal={handleModal}
                        modalTitle="Ubah Unit"
                        inputOneTitle="Nama Unit"
                        inputOneValue={currentData.NamaKendaraan}
                        dropDownKendaraan={true}
                        dropDownKendaraanValue={currentData.CategoryID}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateKendaraan}
                    />
                )}
            </div>
        );
    }
};

export default KendaraanPage;
